import { Avatar } from '@mantine/core';
import { devProxyS3Url } from '@shared/utils/dev-proxy-s3-url';

type ShopAvatarProps = {
  shopName: string;
  logoUrl?: string | null;
  size?: number;
};

function shopInitials(shopName: string) {
  const parts = shopName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return `${parts[0].slice(0, 1)}${parts[1].slice(0, 1)}`.toUpperCase();
}

export function ShopAvatar({ shopName, logoUrl, size = 36 }: ShopAvatarProps) {
  const src = logoUrl ? devProxyS3Url(logoUrl) || logoUrl : undefined;
  return (
    <Avatar
      src={src}
      alt={shopName}
      radius={8}
      size={size}
      color="gray"
      className="seller-support-shop-avatar"
    >
      {shopInitials(shopName)}
    </Avatar>
  );
}
